import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { CommonStore } from 'stores';
import TrackedRoute from './tracked';
import { PATHS } from 'config';
import withTracking from 'tracking/withTracking';
import { route_with_params } from 'helpers';

export default withTracking(
    ({ analytics, prefers = 'login', accessCampaign, ...props }) => {
        const store = useContext(CommonStore);

        const back = props.location.pathname;

        let to = PATHS[prefers === 'login' ? 'login' : 'register'];

        let passedParams = {};
        passedParams.continue = back;

        if (props.component && accessCampaign) {
            to = PATHS.access;
            passedParams.campaign = accessCampaign;
        }

        to = route_with_params(to, passedParams);

        if (!store.user) {
            analytics.setRedirectedFrom(props.location.pathname);
            return <Redirect to={to} />;
        }

        return <TrackedRoute {...props} />;
    },
);
